<script>
import { surveyMethods } from '@state/helpers'

import { mapGetters } from 'vuex'
export default {
  name: 'SurveyHeader',

  props: {
    pageId: {
      type: Number,
      default: 0,
    },
  },

  // data() {
  //   return {
  //     positionAnswer: null,
  //   }
  // },

  computed: {
    ...mapGetters({
      surveys: 'assessment/survey/surveys',
      userAnswers: 'assessment/userAnswer/userAnswers',
    }),
    positionAnswer() {
      if (!this.userAnswers.count) return
      const userAnswer = this.userAnswers.results.find(
        (el) => el.question_detail.id === 16
      )
      if (!userAnswer) return
      return parseInt(userAnswer.answer, 10)
    },
    surveyHeader() {
      if (!this.pageId) return
      switch (this.pageId) {
        case 2:
          return this.surveys.results.find((el) => el.order === 1)
        case 6:
          const formatType = [33, 34].includes(this.positionAnswer) ? 'a' : 'b'
          return this.surveys.results.find(
            (el) => el.format_type === formatType
          )
        case 27:
          return this.surveys.results.find((el) => el.order === 3)
        case 31:
          return this.surveys.results.find((el) => el.order === 4)
        default:
          return ''
      }
    },
  },

  mounted() {
    this.getSurveys()
  },

  methods: {
    ...surveyMethods,
    async getSurveys() {
      try {
        await this.fetchSurveys({ page_size: 10 })
      } catch (error) {
        this.$axios_error_noty(error, this)
      }
    },
  },
}
</script>

<template>
  <div>
    <div v-if="surveyHeader" class="my-2">
      <div class="h4 text-center">{{ surveyHeader.title }}</div>
      <!-- eslint-disable vue/no-v-html -->
      <div v-html="surveyHeader.description">
        <!-- eslint-enable -->
      </div>
    </div>
    <!-- <pre>
        {{ positionAnswer }}
      </pre
    > -->
  </div>
</template>